import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import {
  addCertifiedOrder,
  downloadCertifiedOrder,
  downloadOrder,
  getCertifiedOrders,
  getOrders,
} from "./modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    orders: state.ordersReducer.orders,
    certifiedOrders: state.ordersReducer.certifiedOrders,
    loading: state.ordersReducer.loading,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getOrders,
      getCertifiedOrders,
      downloadOrder,
      downloadCertifiedOrder,
      addCertifiedOrder,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
